import {Link} from "@tanstack/react-router";
import {twMerge} from "tailwind-merge";
import {useAnankePreferences} from "@vesta/ananke/contexts/anankeClientContext";
import intellsysDarkModeLogoUrl from "~/svgs/intellsysHeaderLogo.svg?url";
import intellsysLightModeLogoUrl from "~/svgs/intellsysHeaderLogoDark.svg?url";

export function ErrorPageScaffold({children}: {children: React.ReactNode}) {
    const {theme} = useAnankePreferences();

    return (
        <div className="w-full min-h-[100svh] grid grid-cols-1 grid-rows-[auto_minmax(0,1fr)]">
            <header
                className={twMerge(
                    "w-full sticky top-0 bg-ae-v0--background--500 opacity-100 rounded-none !border-none",
                    "px-5 py-2 md:p-5 h-[var(--gj-signed-out-header-height-mobile)] md:h-[var(--gj-signed-out-header-height)]",
                    "row-start-1 col-start-1 z-50 transition-transform duration-200",
                )}
            >
                <div className="col-start-1 w-full h-full grid grid-flow-col auto-cols-max justify-between items-center">
                    <Link
                        to="/u"
                        className="max-w-[10rem]"
                    >
                        <img
                            src={theme === "light" ? intellsysLightModeLogoUrl : intellsysDarkModeLogoUrl}
                            className="h-6 md:h-[1.75rem]"
                        />
                    </Link>
                </div>
            </header>

            <div
                className={twMerge(
                    "w-full h-full min-h-fit px-[clamp(1.5rem,5vw,6rem)] py-[2.5rem] grid grid-flow-row relative",
                )}
                style={{
                    // 2.25rem
                    gridTemplateRows:
                        "minmax(2rem,1fr) [center-start] auto [center-end] minmax(2rem,1fr) var(--gj-signed-out-header-height) [bottom-text-start] 2.25rem [bottom-text-end]",
                }}
            >
                <div className="row-[center-start/center-end]">{children}</div>

                <div className="row-[bottom-text-start/bottom-text-end] w-full max-w-lg mx-auto grid grid-cols-1 place-items-center text-center text-ae-v0--foreground--400 text-[0.75rem] leading-[1.5]">
                    <span className="h-[1.125rem]" />
                    <span className="h-[1.125rem]">🐈‍⬛</span>
                </div>
            </div>
        </div>
    );
}
